export default __webpack_public_path__ + "static/media/updatehistory.a2bbdc96.svg";